var CallBackOptionSuccessView, CallBackPhoneNumberModel, CommonBaseInputsView, EmailFormDropDownView, EmailFormEmailInputView, EmailFormPhoneNumberInputView, EmailFormRecaptchaView, EmailFormTextLineInputView, EmailFormUserNameInputView, HoldTimeModel, HoldTimeView, PhoneNumberCallBackView, SupportCallMeBackPhoneNumberObjectsTemplate, SupportPhoneNumberWithCallBackTemplate, SupportProgressBarView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportProgressBarView = require('../../progress_bar_view.coffee');

CommonBaseInputsView = require("../../common/views/common_base_inputs_view");

CallBackPhoneNumberModel = require("../../../models/call_back_phone_number_model");

HoldTimeView = require("./hold_time_view");

HoldTimeModel = require("../../../models/hold_time_model");

EmailFormPhoneNumberInputView = require("../../common/views/phone_number_input");

EmailFormEmailInputView = require("../../common/views/email_input_view");

EmailFormDropDownView = require("../../common/views/language_dropdown_input_view");

EmailFormUserNameInputView = require("../INTL/user_name_input_view");

EmailFormTextLineInputView = require("../../common/views/text_line_input_view");

EmailFormRecaptchaView = require("../common/recaptcha_view");

SupportPhoneNumberWithCallBackTemplate = require('../../../../phone_number_with_call_back.html.mustache');

SupportCallMeBackPhoneNumberObjectsTemplate = require('../../../../call_me_back_phone_number_objects.html.mustache');

CallBackOptionSuccessView = require("../common/call_me_back_success_view");

PhoneNumberCallBackView = (function(superClass) {
  extend(PhoneNumberCallBackView, superClass);

  function PhoneNumberCallBackView() {
    this.renderHoldTimePostError = bind(this.renderHoldTimePostError, this);
    this.renderHoldTimePostSuccess = bind(this.renderHoldTimePostSuccess, this);
    return PhoneNumberCallBackView.__super__.constructor.apply(this, arguments);
  }

  PhoneNumberCallBackView.prototype.initialize = function() {
    CommonBaseInputsView.prototype.initialize.apply(this, arguments);
    this.template = SupportPhoneNumberWithCallBackTemplate;
    this.mainView = this.options.mainView;
    this.model = new CallBackPhoneNumberModel();
    this.callBackContainer = $('.help-wizard-content');
    this.inputObjects = this.model.getDefaultPhoneForm().objects;
    this.holdTimeModel = new HoldTimeModel();
    return this.holdTimeView = new HoldTimeView({
      model: this.holdTimeModel
    });
  };

  PhoneNumberCallBackView.prototype.render = function() {
    this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
    this.renderProgressBar();
    this.callBackContainer.html(this.el);
    this.renderInputViews(this.inputObjects, "#call-me-back-inputs");
    this.addAriaLabelToRecaptcha();
    return this.holdTimeView.render();
  };

  PhoneNumberCallBackView.prototype.getViewByObjectType = function(obj) {
    var options;
    options = {
      model: obj,
      validateEmailForm: this.validateEmailForm,
      template: SupportCallMeBackPhoneNumberObjectsTemplate
    };
    switch (obj.type) {
      case 'phone_number':
        return new EmailFormPhoneNumberInputView(options);
      case 'email_address':
        return new EmailFormEmailInputView(options);
      case 'user_name':
        return new EmailFormUserNameInputView(options);
      case 'language_dropDown':
        return new EmailFormDropDownView(options);
      case 'text_description':
        return new EmailFormTextLineInputView(options);
      case 'recaptcha':
        return new EmailFormRecaptchaView(options);
    }
  };

  PhoneNumberCallBackView.prototype.renderNormalPhoneNumberView = function() {
    this.closeModal();
    return this.mainView.renderNormalPhoneNumberView();
  };

  PhoneNumberCallBackView.prototype.onSubmitClick = function() {
    return CommonBaseInputsView.prototype.onSubmitClick.apply(this, arguments);
  };

  PhoneNumberCallBackView.prototype.onLanguageChange = function(event) {
    var locale;
    locale = $("#languageDropdown option:selected").attr("value");
    return this.holdTimeView.updateHoldTime(locale);
  };

  PhoneNumberCallBackView.prototype.addAriaLabelToRecaptcha = function() {
    return $('.g-recaptcha-response').attr("aria-label", "recaptcha");
  };

  PhoneNumberCallBackView.prototype.submitForm = function(data) {
    window.hideDOMElems($('.call-back-phone-number'));
    this.model.postToHoldTime(data, this.renderHoldTimePostSuccess, this.renderHoldTimePostError);
    $(document.createElement('div')).attr('id', 'call-back-final-page-spinner').appendTo('#help-wizard');
    return this.holdTimeView.showLoadingSpinner('#call-back-final-page-spinner', '50px');
  };

  PhoneNumberCallBackView.prototype.enableSubmit = function() {
    $('.call-back-submit-button', this.$el).removeClass('opacity-half');
    return CommonBaseInputsView.prototype.enableSubmit.apply(this, arguments);
  };

  PhoneNumberCallBackView.prototype.disableSubmit = function() {
    $('.call-back-submit-button', this.$el).addClass('opacity-half');
    return CommonBaseInputsView.prototype.disableSubmit.apply(this, arguments);
  };

  PhoneNumberCallBackView.prototype.goToPreviousStep = function() {
    return Groupon.Support.HelpWizardViewManager.renderContactChannels();
  };

  PhoneNumberCallBackView.prototype.getObject = function(type, inputObjects) {
    return _.find(inputObjects, function(object) {
      if (object['model'].type === type) {
        return object;
      }
    });
  };

  PhoneNumberCallBackView.prototype.validateOnFocusOut = function(DomElement, inputObjects) {
    var viewObject;
    if (DomElement.hasClass('call-back-email-input')) {
      viewObject = this.getObject("email_address", inputObjects);
      return viewObject.isInputValid(false);
    } else if (DomElement.hasClass('call-back-phone-number-input')) {
      viewObject = this.getObject("phone_number", inputObjects);
      return viewObject.isInputValid(false);
    }
  };

  PhoneNumberCallBackView.prototype.removeCallBackStepThree = function() {
    var ref;
    return (ref = $('#help-wizard .horizontal')) != null ? ref.remove() : void 0;
  };

  PhoneNumberCallBackView.prototype.renderHoldTimePostSuccess = function(response, locale, userPhoneNumber) {
    this.holdTimeView.hideLoadingSpinner('#call-back-final-page-spinner');
    this.removeCallBackStepThree();
    if (evaluate(response != null ? response.agentNotAvailable : void 0)) {
      return propagateEventBeforeReplacingElements((function(_this) {
        return function() {
          return _this.mainView.callBackErrorHandler(true);
        };
      })(this));
    } else {
      propagateEventBeforeReplacingElements((function(_this) {
        return function() {
          var waitTimeInText;
          waitTimeInText = _this.holdTimeModel.getWaitTimeForLocale(locale);
          _this.callBackSuccessView = new CallBackOptionSuccessView();
          _this.callBackSuccessView.render({
            waitTime: waitTimeInText,
            phone_number: userPhoneNumber
          });
          return $('#help-wizard').append(_this.callBackSuccessView.el);
        };
      })(this));
      return window.hideFooterLinks();
    }
  };

  PhoneNumberCallBackView.prototype.renderHoldTimePostError = function() {
    this.holdTimeView.hideLoadingSpinner('#call-back-final-page-spinner');
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        return _this.mainView.callBackErrorHandler(false);
      };
    })(this));
  };

  PhoneNumberCallBackView.prototype.renderProgressBar = function() {
    var progressBar;
    progressBar = new SupportProgressBarView;
    progressBar.render();
    return this.$el.find('.steps-container').append(progressBar.el);
  };

  PhoneNumberCallBackView.prototype.closeModal = function() {
    GIG.Modal.close();
    return false;
  };

  PhoneNumberCallBackView.prototype.events = {
    'click .close-modal': "closeModal",
    'click .b-close': "closeModal",
    'click .submit-button': 'onSubmitClick',
    'click #back': 'goToPreviousStep',
    'focusin .call-back-inputs': "focusFormInput",
    'focusout .call-back-inputs': "focusoutFormInput",
    'change #languageDropdown': "onLanguageChange"
  };

  return PhoneNumberCallBackView;

})(CommonBaseInputsView);

module.exports = PhoneNumberCallBackView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9VUy9waG9uZV9udW1iZXJfY2FsbF9iYWNrX3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9VUy9waG9uZV9udW1iZXJfY2FsbF9iYWNrX3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsMllBQUE7RUFBQTs7OztBQUFBLHNCQUFBLEdBQXlCLE9BQUEsQ0FBUSxnQ0FBUjs7QUFDekIsb0JBQUEsR0FBdUIsT0FBQSxDQUFRLDRDQUFSOztBQUN2Qix3QkFBQSxHQUEyQixPQUFBLENBQVEsOENBQVI7O0FBQzNCLFlBQUEsR0FBZSxPQUFBLENBQVEsa0JBQVI7O0FBQ2YsYUFBQSxHQUFnQixPQUFBLENBQVEsaUNBQVI7O0FBQ2hCLDZCQUFBLEdBQWdDLE9BQUEsQ0FBUSx1Q0FBUjs7QUFDaEMsdUJBQUEsR0FBMEIsT0FBQSxDQUFRLHFDQUFSOztBQUMxQixxQkFBQSxHQUF3QixPQUFBLENBQVEsaURBQVI7O0FBQ3hCLDBCQUFBLEdBQTZCLE9BQUEsQ0FBUSw4QkFBUjs7QUFDN0IsMEJBQUEsR0FBNkIsT0FBQSxDQUFRLHlDQUFSOztBQUM3QixzQkFBQSxHQUF5QixPQUFBLENBQVEsMEJBQVI7O0FBQ3pCLHNDQUFBLEdBQXlDLE9BQUEsQ0FBUSx1REFBUjs7QUFDekMsMkNBQUEsR0FBOEMsT0FBQSxDQUFRLDZEQUFSOztBQUM5Qyx5QkFBQSxHQUE0QixPQUFBLENBQVEscUNBQVI7O0FBRXRCOzs7Ozs7Ozs7b0NBRUosVUFBQSxHQUFZLFNBQUE7SUFDVixvQkFBb0IsQ0FBQSxTQUFFLENBQUEsVUFBVSxDQUFDLEtBQWpDLENBQXVDLElBQXZDLEVBQTZDLFNBQTdDO0lBQ0EsSUFBQyxDQUFBLFFBQUQsR0FBWTtJQUNaLElBQUMsQ0FBQSxRQUFELEdBQVksSUFBQyxDQUFBLE9BQU8sQ0FBQztJQUNyQixJQUFDLENBQUEsS0FBRCxHQUFTLElBQUksd0JBQUosQ0FBQTtJQUNULElBQUMsQ0FBQSxpQkFBRCxHQUFxQixDQUFBLENBQUUsc0JBQUY7SUFDckIsSUFBQyxDQUFBLFlBQUQsR0FBaUIsSUFBQyxDQUFBLEtBQUssQ0FBQyxtQkFBUCxDQUFBLENBQTRCLENBQUM7SUFDOUMsSUFBQyxDQUFBLGFBQUQsR0FBaUIsSUFBSSxhQUFKLENBQUE7V0FDakIsSUFBQyxDQUFBLFlBQUQsR0FBZ0IsSUFBSSxZQUFKLENBQWlCO01BQUMsS0FBQSxFQUFPLElBQUMsQ0FBQSxhQUFUO0tBQWpCO0VBUk47O29DQVVaLE1BQUEsR0FBUSxTQUFBO0lBQ04sSUFBQyxDQUFBLEdBQUcsQ0FBQyxNQUFMLENBQVksTUFBQSxDQUFPLElBQUMsQ0FBQSxRQUFSLEVBQWtCLElBQUMsQ0FBQSxNQUFELENBQUEsQ0FBbEIsRUFBNkIsSUFBQyxDQUFBLFNBQTlCLENBQVo7SUFDQSxJQUFDLENBQUEsaUJBQUQsQ0FBQTtJQUNBLElBQUMsQ0FBQSxpQkFBaUIsQ0FBQyxJQUFuQixDQUF3QixJQUFDLENBQUEsRUFBekI7SUFDQSxJQUFDLENBQUEsZ0JBQUQsQ0FBa0IsSUFBQyxDQUFBLFlBQW5CLEVBQWlDLHNCQUFqQztJQUNBLElBQUMsQ0FBQSx1QkFBRCxDQUFBO1dBQ0EsSUFBQyxDQUFBLFlBQVksQ0FBQyxNQUFkLENBQUE7RUFOTTs7b0NBUVIsbUJBQUEsR0FBb0IsU0FBQyxHQUFEO0FBQ2xCLFFBQUE7SUFBQSxPQUFBLEdBQ0U7TUFBQSxLQUFBLEVBQU8sR0FBUDtNQUNBLGlCQUFBLEVBQW1CLElBQUMsQ0FBQSxpQkFEcEI7TUFFQSxRQUFBLEVBQVUsMkNBRlY7O0FBSUYsWUFBTyxHQUFHLENBQUMsSUFBWDtBQUFBLFdBQ08sY0FEUDtlQUM0QixJQUFJLDZCQUFKLENBQWtDLE9BQWxDO0FBRDVCLFdBRU8sZUFGUDtlQUU0QixJQUFJLHVCQUFKLENBQTRCLE9BQTVCO0FBRjVCLFdBR08sV0FIUDtlQUc0QixJQUFJLDBCQUFKLENBQStCLE9BQS9CO0FBSDVCLFdBSU8sbUJBSlA7ZUFJZ0MsSUFBSSxxQkFBSixDQUEwQixPQUExQjtBQUpoQyxXQUtPLGtCQUxQO2VBSytCLElBQUksMEJBQUosQ0FBK0IsT0FBL0I7QUFML0IsV0FNTyxXQU5QO2VBTXdCLElBQUksc0JBQUosQ0FBMkIsT0FBM0I7QUFOeEI7RUFOa0I7O29DQWNwQiwyQkFBQSxHQUE2QixTQUFBO0lBQzNCLElBQUMsQ0FBQSxVQUFELENBQUE7V0FDQSxJQUFDLENBQUEsUUFBUSxDQUFDLDJCQUFWLENBQUE7RUFGMkI7O29DQUk3QixhQUFBLEdBQWUsU0FBQTtXQUNiLG9CQUFvQixDQUFBLFNBQUUsQ0FBQSxhQUFhLENBQUMsS0FBcEMsQ0FBMEMsSUFBMUMsRUFBZ0QsU0FBaEQ7RUFEYTs7b0NBR2YsZ0JBQUEsR0FBa0IsU0FBQyxLQUFEO0FBQ2hCLFFBQUE7SUFBQSxNQUFBLEdBQVMsQ0FBQSxDQUFFLG1DQUFGLENBQXNDLENBQUMsSUFBdkMsQ0FBNEMsT0FBNUM7V0FDVCxJQUFDLENBQUEsWUFBWSxDQUFDLGNBQWQsQ0FBNkIsTUFBN0I7RUFGZ0I7O29DQUlsQix1QkFBQSxHQUF5QixTQUFBO1dBQ3ZCLENBQUEsQ0FBRSx1QkFBRixDQUEwQixDQUFDLElBQTNCLENBQWdDLFlBQWhDLEVBQTZDLFdBQTdDO0VBRHVCOztvQ0FHekIsVUFBQSxHQUFZLFNBQUMsSUFBRDtJQUNWLE1BQU0sQ0FBQyxZQUFQLENBQW9CLENBQUEsQ0FBRSx5QkFBRixDQUFwQjtJQUNBLElBQUMsQ0FBQSxLQUFLLENBQUMsY0FBUCxDQUFzQixJQUF0QixFQUE0QixJQUFDLENBQUEseUJBQTdCLEVBQXdELElBQUMsQ0FBQSx1QkFBekQ7SUFDQSxDQUFBLENBQUUsUUFBUSxDQUFDLGFBQVQsQ0FBdUIsS0FBdkIsQ0FBRixDQUFnQyxDQUFDLElBQWpDLENBQXNDLElBQXRDLEVBQTJDLDhCQUEzQyxDQUEwRSxDQUFDLFFBQTNFLENBQW9GLGNBQXBGO1dBQ0EsSUFBQyxDQUFBLFlBQVksQ0FBQyxrQkFBZCxDQUFpQywrQkFBakMsRUFBa0UsTUFBbEU7RUFKVTs7b0NBTVosWUFBQSxHQUFjLFNBQUE7SUFDWixDQUFBLENBQUUsMEJBQUYsRUFBOEIsSUFBQyxDQUFBLEdBQS9CLENBQW1DLENBQUMsV0FBcEMsQ0FBZ0QsY0FBaEQ7V0FDQSxvQkFBb0IsQ0FBQSxTQUFFLENBQUEsWUFBWSxDQUFDLEtBQW5DLENBQXlDLElBQXpDLEVBQStDLFNBQS9DO0VBRlk7O29DQUlkLGFBQUEsR0FBZSxTQUFBO0lBQ2IsQ0FBQSxDQUFFLDBCQUFGLEVBQThCLElBQUMsQ0FBQSxHQUEvQixDQUFtQyxDQUFDLFFBQXBDLENBQTZDLGNBQTdDO1dBQ0Esb0JBQW9CLENBQUEsU0FBRSxDQUFBLGFBQWEsQ0FBQyxLQUFwQyxDQUEwQyxJQUExQyxFQUFnRCxTQUFoRDtFQUZhOztvQ0FJZixnQkFBQSxHQUFrQixTQUFBO1dBQ2hCLE9BQU8sQ0FBQyxPQUFPLENBQUMscUJBQXFCLENBQUMscUJBQXRDLENBQUE7RUFEZ0I7O29DQUdsQixTQUFBLEdBQVcsU0FBQyxJQUFELEVBQU8sWUFBUDtXQUNULENBQUMsQ0FBQyxJQUFGLENBQU8sWUFBUCxFQUFxQixTQUFDLE1BQUQ7TUFDbkIsSUFBRyxNQUFPLENBQUEsT0FBQSxDQUFRLENBQUMsSUFBaEIsS0FBd0IsSUFBM0I7QUFDRSxlQUFPLE9BRFQ7O0lBRG1CLENBQXJCO0VBRFM7O29DQU1YLGtCQUFBLEdBQW9CLFNBQUMsVUFBRCxFQUFhLFlBQWI7QUFDbEIsUUFBQTtJQUFBLElBQUcsVUFBVSxDQUFDLFFBQVgsQ0FBb0IsdUJBQXBCLENBQUg7TUFDRSxVQUFBLEdBQWEsSUFBQyxDQUFBLFNBQUQsQ0FBVyxlQUFYLEVBQTRCLFlBQTVCO2FBQ2IsVUFBVSxDQUFDLFlBQVgsQ0FBd0IsS0FBeEIsRUFGRjtLQUFBLE1BR0ssSUFBRyxVQUFVLENBQUMsUUFBWCxDQUFvQiw4QkFBcEIsQ0FBSDtNQUNILFVBQUEsR0FBYSxJQUFDLENBQUEsU0FBRCxDQUFXLGNBQVgsRUFBMkIsWUFBM0I7YUFDYixVQUFVLENBQUMsWUFBWCxDQUF3QixLQUF4QixFQUZHOztFQUphOztvQ0FRcEIsdUJBQUEsR0FBeUIsU0FBQTtBQUN2QixRQUFBOzhEQUE2QixDQUFFLE1BQS9CLENBQUE7RUFEdUI7O29DQUd6Qix5QkFBQSxHQUEyQixTQUFDLFFBQUQsRUFBVyxNQUFYLEVBQW1CLGVBQW5CO0lBQ3pCLElBQUMsQ0FBQSxZQUFZLENBQUMsa0JBQWQsQ0FBaUMsK0JBQWpDO0lBQ0EsSUFBQyxDQUFBLHVCQUFELENBQUE7SUFDQSxJQUFHLFFBQUEsb0JBQVMsUUFBUSxDQUFFLDBCQUFuQixDQUFIO2FBQ0UscUNBQUEsQ0FBdUMsQ0FBQSxTQUFBLEtBQUE7ZUFBQSxTQUFBO2lCQUNyQyxLQUFDLENBQUEsUUFBUSxDQUFDLG9CQUFWLENBQStCLElBQS9CO1FBRHFDO01BQUEsQ0FBQSxDQUFBLENBQUEsSUFBQSxDQUF2QyxFQURGO0tBQUEsTUFBQTtNQUtFLHFDQUFBLENBQXVDLENBQUEsU0FBQSxLQUFBO2VBQUEsU0FBQTtBQUNyQyxjQUFBO1VBQUEsY0FBQSxHQUFpQixLQUFDLENBQUEsYUFBYSxDQUFDLG9CQUFmLENBQW9DLE1BQXBDO1VBQ2pCLEtBQUMsQ0FBQSxtQkFBRCxHQUF1QixJQUFJLHlCQUFKLENBQUE7VUFDdkIsS0FBQyxDQUFBLG1CQUFtQixDQUFDLE1BQXJCLENBQTRCO1lBQUMsUUFBQSxFQUFVLGNBQVg7WUFBMkIsWUFBQSxFQUFjLGVBQXpDO1dBQTVCO2lCQUNBLENBQUEsQ0FBRSxjQUFGLENBQWlCLENBQUMsTUFBbEIsQ0FBeUIsS0FBQyxDQUFBLG1CQUFtQixDQUFDLEVBQTlDO1FBSnFDO01BQUEsQ0FBQSxDQUFBLENBQUEsSUFBQSxDQUF2QzthQU1BLE1BQU0sQ0FBQyxlQUFQLENBQUEsRUFYRjs7RUFIeUI7O29DQWdCM0IsdUJBQUEsR0FBeUIsU0FBQTtJQUN2QixJQUFDLENBQUEsWUFBWSxDQUFDLGtCQUFkLENBQWlDLCtCQUFqQztXQUNBLHFDQUFBLENBQXVDLENBQUEsU0FBQSxLQUFBO2FBQUEsU0FBQTtlQUNyQyxLQUFDLENBQUEsUUFBUSxDQUFDLG9CQUFWLENBQStCLEtBQS9CO01BRHFDO0lBQUEsQ0FBQSxDQUFBLENBQUEsSUFBQSxDQUF2QztFQUZ1Qjs7b0NBTXpCLGlCQUFBLEdBQW1CLFNBQUE7QUFDakIsUUFBQTtJQUFBLFdBQUEsR0FBYyxJQUFJO0lBQ2xCLFdBQVcsQ0FBQyxNQUFaLENBQUE7V0FDQSxJQUFDLENBQUEsR0FBRyxDQUFDLElBQUwsQ0FBVSxrQkFBVixDQUE2QixDQUFDLE1BQTlCLENBQXFDLFdBQVcsQ0FBQyxFQUFqRDtFQUhpQjs7b0NBS25CLFVBQUEsR0FBWSxTQUFBO0lBQ1YsR0FBRyxDQUFDLEtBQUssQ0FBQyxLQUFWLENBQUE7QUFDQSxXQUFPO0VBRkc7O29DQUlaLE1BQUEsR0FDRTtJQUFBLG9CQUFBLEVBQXVCLFlBQXZCO0lBQ0EsZ0JBQUEsRUFBbUIsWUFEbkI7SUFFQSxzQkFBQSxFQUF3QixlQUZ4QjtJQUdBLGFBQUEsRUFBZ0Isa0JBSGhCO0lBSUEsMkJBQUEsRUFBNkIsZ0JBSjdCO0lBS0EsNEJBQUEsRUFBOEIsbUJBTDlCO0lBTUEsMEJBQUEsRUFBNEIsa0JBTjVCOzs7OztHQWxIa0M7O0FBMEh0QyxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
